module.exports = __webpack_public_path__ + "images/_/assets/images/logo_riogrande.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_riogrande.png
// module id = ./src/assets/images/logo_riogrande.png
// module chunks = 1